<focus-select [select]="selected">
  <div class="container-expandable">
    <div class="expandable">
      <div class="header">
        <div class="title">
          <ng-content select="[title]"></ng-content>
        </div>
        <button
          *ngIf="mbExpandablePanel !== undefined"
          class="button-expandable"
          [mb-expandable-panel]="panelExpandable"
          (click)="openPanel()"
        >
          <span *ngIf="mbExpandablePanel.expanded()"
            ><mb-icon icon="arrow-up"></mb-icon
          ></span>
          <span *ngIf="!mbExpandablePanel.expanded()"
            ><mb-icon icon="arrow-down"></mb-icon
          ></span>
        </button>
      </div>
      <div #bodyExpandable class="body-expandable">
        <div class="static-expandable">
          <ng-content select="[static]"></ng-content>
        </div>
        <mb-expandable-panel class="expandable-panel" #panelExpandable>
          <div class="content-expandable-panel" #contentText>
            <ng-content select="[body]"> </ng-content>
          </div>
        </mb-expandable-panel>
      </div>
    </div>
    <div class="footer-expandable">
      <ng-content> </ng-content>
    </div>
  </div>
</focus-select>
